export const DEVICE_KIND = {
  AUDIO: 'audio',
  VIDEO: 'video'
};
